import client from './axiosClient';
export const getTasks         = ()       => client.get('/tasks');
export const getMyTasks       = ()       => client.get('/tasks/my');
export const getTask          = id       => client.get(`/tasks/${id}`);
export const createTask       = dto      => client.post('/tasks', dto);
export const updateTask       = (id,dto) => client.put(`/tasks/${id}`, dto);
export const updateTaskStatus = (id,dto) => client.patch(`/tasks/${id}/status`, dto);
export const changeAssignee   = (id,dto) => client.patch(`/tasks/${id}/assignee`, dto);
export const addComment       = (id,dto) => client.post(`/tasks/${id}/comments`, dto);
export const requestApproval  = (id,dto) => client.post(`/tasks/${id}/approval-request`, dto);
